import gapi from './gapi';

const googleFileLoader = ({ fileId, setUrl }) => {
  gapi.client.drive.files
    .get({
      includeItemsFromAllDrives: true,
      supportsAllDrives: true,
      alt: 'media',
      fileId,
      contentEncoding: 'blob'
    })
    .then(function (resp) {
      console.log(resp);
      const base64 =
        'data:' + 'mimeType' + ';base64,' + Buffer.from(resp.body, 'binary').toString('base64');
      setUrl(base64);
    });
};

export default googleFileLoader;
